import React, { useState } from 'react';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import '../App.css';
import './ConfirmationEmail.css';
import { ContentTitle } from './ContentTitle';
import { checkIsReschedule, getUserPrimaryEmail } from './Function';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function ConfirmationEmail({
  parentPrimaryContactCallback,
  userMobile,
  userMobileDialCode,
  reschedulePassengerNumber,
}) {
  const checkReschedule = checkIsReschedule();
  const [phone, setPhone] = useState(
    checkReschedule == true
      ? reschedulePassengerNumber != ''
        ? reschedulePassengerNumber
        : '60'
      : userMobile != ''
        ? userMobile
        : '60',
  );

  // const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState(
    userMobileDialCode?.replace('+', '') || '60',
  );
  // console.log(reschedulePassengerNumber)
  return (
    <>
      <div className='confirmationEmail'>
        <ContentTitle
          title='Confirmation Email'
          description='We will send your confirmation to this email.'
          button={null}
        />
        <div className='confirmationEmail_content pt-3'>
          <Form>
            <Row>
              <h3>Your confirmation will be sent to this email address.</h3>
              <Form.Control
                disabled={checkReschedule == true ? true : false}
                type='email'
                placeholder='Your email'
                defaultValue={getUserPrimaryEmail()}
                onChange={(event) =>
                  parentPrimaryContactCallback(
                    event,
                    event.target.value,
                    'primary_email',
                  )
                }
              />
            </Row>
            <Row>
              <h3>Your contact number</h3>
              {/* <Form.Control
                disabled={checkReschedule == true ? true : false}
                type='text'
                placeholder='Your contact'
                defaultValue={
                  checkReschedule == true
                    ? reschedulePassengerNumber != ''
                      ? reschedulePassengerNumber
                      : ''
                    : userMobile != ''
                    ? userMobile
                    : ''
                }
                onChange={(event) =>
                  parentPrimaryContactCallback(
                    event,
                    event.target.value,
                    'primary_contact'
                  )
                }
              /> */}

              <PhoneInput
                country={'my'}
                dialCode={countryCode}
                value={`${phone}`}
                onChange={(value, data) => {
                  if (data.dialCode !== countryCode) {
                    setCountryCode(data.dialCode);
                    setPhone('');
                  } else {
                    setPhone(value);

                    parentPrimaryContactCallback(
                      value,
                      value,
                      'primary_contact',
                    );
                    parentPrimaryContactCallback(
                      value,
                      data.dialCode,
                      'country_code',
                    );
                  }
                }}
                inputStyle={{
                  width: '100% !important',
                  border: ' 1px solid #003A81',
                  borderRadius: '3px',
                }}
                buttonStyle={{ border: ' 1px solid #003A81' }}
                containerStyle={{ margin: '0 20px 10px 30px', padding: '0' }}
                preferredCountries={['my', 'sg']}
                enableSearch={true}
                disabled={checkReschedule == true ? true : false}
              />
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ConfirmationEmail;
